<hyperkit-dialog class="hyperkit-component" headerText="Send Us Feedback">
  @if (!submitted) {
    <hyperkit-typography variant="body" size="md" align="left" color="body">
      Use this form to provide feedback to the Intel 471 Research Team about any
      issues with the Hunt Packages, Content, or Threat Intelligence information
      presented. Screen reader support enabled.
      <br />
      For any other type of support or feedback, please visit our
      <a routerLink="/customer-support" (click)="return()">Support</a> page.
    </hyperkit-typography>
    <form [formGroup]="feedbackForm" (ngSubmit)="onSendFeedBack()">
      <ul class="k-radio-list k-list-horizontal pt-2">
        @for (type of feedbackTypes; track type) {
          <li class="k-radio-item">
            <hyperkit-radio-button
              formControlName="feedbackType"
              [value]="type"
              text="{{ type }}"
              name="feedbackType"
            >
            </hyperkit-radio-button>
          </li>
        }
      </ul>
      <hyperkit-typography variant="body" size="sm" align="left" color="body">{{
        feedbackExplanations[this.feedbackForm.value.feedbackType]
      }}</hyperkit-typography>
      <div class="row">
        <div class="col-12">
          @if (error) {
            <hyperkit-error [error]="error"></hyperkit-error>
          }
        </div>
        <div class="col-12">
          <hyperkit-textarea
            label="Message"
            class="hyperkit-component"
            placeholder="Please leave your message here"
            formControlName="message"
          >
          </hyperkit-textarea>
        </div>
      </div>
      <hyperkit-button
        size="small"
        color="tertiary"
        text="Submit"
        type="submit"
        [disabled]="!feedbackForm.valid"
      ></hyperkit-button>
    </form>
  }
  @if (submitted) {
    <ng-container class="submitted">
      <hyperkit-typography variant="h3" align="left" color="primary"
        >Your Message has been sent!</hyperkit-typography
      >
      <hyperkit-typography variant="body" size="sm" align="left" color="body"
        >The Intel 471 Support Team will respond shortly.
      </hyperkit-typography>
      <hyperkit-button
        size="small"
        color="tertiary"
        text="Close"
        (click)="return()"
      ></hyperkit-button>
    </ng-container>
  }
</hyperkit-dialog>
